export default [
  "coveredRiskType",
  "coverType",
  "contractingParty",
  "totalInsuredPremium.amount",
  "evaluationType",
  "policyType",
];
